import { FC } from "react";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import styles from "./ClearAllModal.module.scss";

interface ClearAllModalProps {
  onClose: () => void;
  onClearAll: () => void;
  isClearingAll?: boolean;
}

const ClearAllModal: FC<ClearAllModalProps> = ({
  onClose,
  onClearAll,
  isClearingAll,
}) => {
  /* --------------------------------------------------------------------------
   * Render
   * -------------------------------------------------------------------------- */
  return (
    <div className="create-promotion-modal">
      <Backdrop open={true}>
        <div className={styles["modalContainer"]}>
          {/* Modal Title */}
          <h4 className={styles["modalContainer__title"]}>Clear All</h4>

          {/* Warning Message */}
          <div className={styles["modalContainer__inputWrapper"]}>
            Clearing all entries will reset the form to its default state.
            Ensure that you've saved any necessary information before
            proceeding.
          </div>

          {/* Action Buttons */}
          <div className={styles["modalContainer__buttonGroup"]}>
            {/* Cancel Button - Disabled during clear operation */}
            <Button
              onClick={onClose}
              className={`${styles["modalContainer__buttonGroup__cancelButton"]} create-promo-cancel-button`}
              variant="outlined"
              disabled={isClearingAll}
            >
              Cancel
            </Button>

            {/* Clear All Button - Shows loading spinner during operation */}
            <Button
              onClick={onClearAll}
              className={`${styles["modalContainer__buttonGroup__submitButton"]} create-promo-submit-button`}
              variant="contained"
              disabled={isClearingAll}
            >
              {isClearingAll ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Clear All"
              )}
            </Button>
          </div>
        </div>
      </Backdrop>
    </div>
  );
};

export default ClearAllModal;
